import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Tooltip,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import defaultRestaurants from "../../assets/defaultRestaurant.json";

const RestaurantCard = ({ restaurant, countryId }) => {
  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * defaultRestaurants.length);
    return defaultRestaurants[randomIndex];
  };

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: 3,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: 0,
          paddingTop: "60%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${restaurant.imgUrl || getRandomImage()})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
            color: "white",
            padding: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              lineHeight: 1.2,
              width: "90%",
            }}
          >
            {restaurant.name}
          </Typography>
        </Box>
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontFamily: "Poppins, sans-serif",
            mb: 1.5,
            minHeight: "3em",
          }}
        >
          {restaurant.description?.substring(0, 50)}
          {restaurant.description?.length > 50 ? "..." : ""}
        </Typography>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontFamily: "Poppins, sans-serif" }}
            >
              {restaurant.prefecture} • {countryId}
            </Typography>
          </Grid>
          <Grid item>
            <Tooltip
              title={
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "14px",
                  }}
                >
                  <LocationOnIcon sx={{ mr: 0.5 }} fontSize="small" />
                  {restaurant.location || "Location not specified"}
                </Stack>
              }
              placement="top"
              arrow
            >
              <LocationOnIcon fontSize="small" sx={{ color: "primary.main" }} />
            </Tooltip>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RestaurantCard;
